<template>
  <aside class="menu no-print fade-in">
    <div v-if="isUser">
      <ul class="menu-list">
        <li v-if="$can('encounter:read|encounter:manage')">
          <router-link
            :to="{ name: 'encounter-list' }"
            exact
            class="columns is-mobile"
          >
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-video-camera left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Virtual Visit</div>
          </router-link>
        </li>
      </ul>
    </div>

    <div v-if="practice.subdomain !== 'public'">
      <p class="menu-label">Practice</p>
      <ul class="menu-list">
        <li v-if="$can('patient_queue:read|patient_queue:manage')">
          <router-link
            :to="{
              name: 'patient-queue-list-with-filter',
              params: { filters: true }
            }"
            exact
            class="columns is-mobile"
          >
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-users left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Patient Queue</div>
          </router-link>
        </li>
        <li
          v-if="
            practice.virtualVisitEnabled &&
              $can('encounter:read|encounter:manage')
          "
        >
          <router-link
            :to="{ name: 'encounter-list' }"
            exact
            class="columns is-mobile"
          >
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-video-camera left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Virtual Visit</div>
          </router-link>
        </li>

        <li v-if="practice.virtualVisitEnabled">
          <a class="columns is-mobile">
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-comment left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Messages</div>
          </a>
        </li>

        <li v-if="practice.virtualVisitEnabled">
          <a class="columns is-mobile">
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-share-alt left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Referrals</div>
          </a>
        </li>

        <li v-if="practice.virtualVisitEnabled">
          <a class="columns is-mobile">
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-shopping-cart left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Marketplace</div>
          </a>
        </li>

        <li v-if="$can('interview:update|interview:manage|interview:read')">
          <router-link
            :to="{ name: 'interview-index' }"
            class="columns is-mobile"
          >
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-file-text-o left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Interviews</div>
          </router-link>
        </li>
        <li v-if="$can('patient_queue:read|patient_queue:manage')">
          <router-link :to="{ name: 'trends' }" exact class="columns is-mobile">
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-line-chart left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Trends</div>
          </router-link>
        </li>
        <li v-if="$can('user:manage') && practice.id">
          <router-link
            :to="{ name: 'user-list', params: { id: practice.id } }"
            exact
            class="columns is-mobile"
          >
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-users left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">User List</div>
          </router-link>
        </li>
      </ul>
    </div>

    <div
      v-if="
        practice.subdomain === 'public' &&
          $can('practice:create|practice:manage')
      "
    >
      <p class="menu-label">Virtriage</p>
      <ul class="menu-list">
        <li>
          <router-link
            :to="{ name: 'practice-list' }"
            class="columns is-mobile"
          >
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-building left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Accounts</div>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'interview-pool' }"
            class="columns is-mobile"
          >
            <div class="column is-pulled-left is-narrow">
              <span class="icon">
                <i class="fa fa-file-text left-nav"></i>
              </span>
            </div>
            <div class="column is-pulled-left">Interview Templates</div>
          </router-link>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  name: "left-menu",

  computed: {
    practice() {
      return this.$store.getters["practice/current"];
    },
    isUser() {
      return this.$store.getters.isUser;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.menu-list {
  margin-top: 4.29rem;
}
</style>
